import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getAuthUserAllowChecklistCount = (
    state: IApplicationState
): number => {
    const user = getAuthUser(state);
    return user.allowChecklistCount;
}
